module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-links"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/plypp",
      "title": "Plypp on Facebook"
    }
  }, [_vm._v("Plypp on Facebook")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/plypp_piano",
      "title": "Plypp on Twitter"
    }
  }, [_vm._v("@plypp_piano")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://plus.google.com/+PlyppNet",
      "title": "Plypp on Google+",
      "rel": "publisher"
    }
  }, [_vm._v("Plypp on G+")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://plypp.userecho.com/",
      "title": "Report bugs"
    }
  }, [_vm._v("Report bugs / Add suggestions")]), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06ae1820!./src/components/social-links/social-links.html
// module id = 109
// module chunks = 2